import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getBanners, getBannersParams } from '../../../api/banners/queries/getBanners';
import { IBanner } from '../../../interfaces/Banner.interfaces';

interface IUseGetBannersQueryParams extends getBannersParams {}

export const useGetBannersQuery = ({ searchParam }: IUseGetBannersQueryParams) => {
  return useQuery<IBanner[], AxiosError>(
    ['banners', `category=${searchParam.category}&outputLocation=${searchParam.outputLocation}`],
    () =>
      getBanners({
        searchParam,
      }),
  );
};
